import { Fragment, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { MdSubdirectoryArrowRight } from "react-icons/md";

type Props = {
    sideBar: any[];
    setSideBar: (value: any[]) => void;
    sideBarHide: boolean;
    setSideBarHide: (value: boolean) => void;
}

const Sidebar = ({ sideBar, setSideBar, sideBarHide, setSideBarHide }: Props) => {
    const location = useLocation();

    const isActive = (path: string) => {
        return location.pathname === path || location.pathname.startsWith(path + "/");
    };

    useEffect(() => {
        const updatedSidebar = sideBar.map((item: any) => {
            if (item.child?.length) {
                const isChildActive = item.child.some((child: any) =>
                    location.pathname.startsWith(child.link)
                );

                return {
                    ...item,
                    isChildVisible: isChildActive,
                };
            }
            return item;
        });

        setSideBar(updatedSidebar);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return (
        <>
            <nav
                className={`admin__sidebar__container block min-md:hidden w-60 md:w-64 min-h-[calc(100vh-72px)] bg-blue-100 fixed left-0 py-6 px-4 transform duration-500 ${sideBarHide ? "-translate-x-full" : "translate-x-0"
                    }`}
            >
                {/* Toggle Button */}
                <div className="relative">
                    <div
                        className={`absolute transform duration-300 ${sideBarHide ? "-right-12" : "-right-6"
                            } top-0 h-6 w-6 p-[6px] cursor-pointer bg-[#2B3998] flex items-center justify-center rounded-full`}
                        onClick={() => setSideBarHide(!sideBarHide)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#fff"
                            className={`w-4 h-4 transform duration-300 ${sideBarHide ? "rotate-0" : "rotate-180"
                                }`}
                            viewBox="0 0 55.752 55.752"
                        >
                            <path d="M43.006 23.916a5.36 5.36 0 0 0-.912-.727L20.485 1.581a5.4 5.4 0 0 0-7.637 7.638l18.611 18.609-18.705 18.707a5.398 5.398 0 1 0 7.634 7.635l21.706-21.703a5.35 5.35 0 0 0 .912-.727 5.373 5.373 0 0 0 1.574-3.912 5.363 5.363 0 0 0-1.574-3.912z" />
                        </svg>
                    </div>
                </div>

                <div className="overflow-auto max-h-[calc(100vh-142px)] mt-10">
                    {sideBar.map((item: any, index: number) => (
                        <Fragment key={index}>
                            {/* ================= PARENT ================= */}
                            {item.link === "" ? (
                                <div
                                    className="flex cursor-pointer group gap-4 py-2 my-1 px-1 md:px-4"
                                    onClick={() => {
                                        const result = [...sideBar];
                                        result[index] = {
                                            ...result[index],
                                            isChildVisible: !item.isChildVisible,
                                        };
                                        setSideBar(result);
                                    }}
                                >
                                    <h6 className="text-gray-600 group-hover:text-black text-sm font-bold flex-1">
                                        {item.name}
                                    </h6>

                                    {item.child.length !== 0 && (
                                        <svg
                                            className={`w-3 fill-gray-600 group-hover:fill-black ${item.isChildVisible ? "rotate-0" : "-rotate-90"
                                                }`}
                                            viewBox="0 0 451.847 451.847"
                                        >
                                            <path d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z" />
                                        </svg>
                                    )}
                                </div>
                            ) : (
                                <Link
                                    to={item.link}
                                    className={`flex cursor-pointer group py-2 my-1 rounded-md transition ${isActive(item.link)
                                        ? "bg-secondary text-white"
                                        : "hover:bg-blue-200"
                                        }`}
                                >
                                    <h6
                                        className={`text-sm font-bold px-4 flex-1 ${isActive(item.link)
                                            ? "text-white"
                                            : "text-gray-600 group-hover:text-black"
                                            }`}
                                    >
                                        {item.name}
                                    </h6>
                                </Link>
                            )}

                            {/* ================= CHILD ================= */}
                            {item.isChildVisible && (
                                <ul className="space-y-2 mt-1 pl-4">
                                    {item.child.map((childItem: any, childIndex: number) => (
                                        <li key={childIndex}>
                                            <Link
                                                to={childItem.link}
                                                className={`text-sm flex items-center rounded-md px-4 py-1 transition ${isActive(childItem.link)
                                                    ? "bg-secondary text-white"
                                                    : "text-gray-600 hover:text-black hover:bg-blue-50"
                                                    }`}
                                            >
                                                <MdSubdirectoryArrowRight className="mr-2" />
                                                <span>{childItem.name}</span>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </Fragment>
                    ))}
                </div>
            </nav>


            <nav
                className={`admin__sidebar__container hidden max-md:block w-60 md:w-64 min-h-[calc(100vh-72px)] bg-blue-100 fixed left-0 py-6 px-4 transform duration-500 ${sideBarHide ? "-translate-x-full" : "translate-x-0"
                    }`}
            >
                {/* Toggle Button */}
                <div className="relative">
                    <div
                        className={`absolute transform duration-300 ${sideBarHide ? "-right-12" : "-right-6"
                            } top-0 h-6 w-6 p-[6px] cursor-pointer bg-[#2B3998] flex items-center justify-center rounded-full`}
                        onClick={() => setSideBarHide(!sideBarHide)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#fff"
                            className={`w-4 h-4 transform duration-300 ${sideBarHide ? "rotate-0" : "rotate-180"
                                }`}
                            viewBox="0 0 55.752 55.752"
                        >
                            <path d="M43.006 23.916a5.36 5.36 0 0 0-.912-.727L20.485 1.581a5.4 5.4 0 0 0-7.637 7.638l18.611 18.609-18.705 18.707a5.398 5.398 0 1 0 7.634 7.635l21.706-21.703a5.35 5.35 0 0 0 .912-.727 5.373 5.373 0 0 0 1.574-3.912 5.363 5.363 0 0 0-1.574-3.912z" />
                        </svg>
                    </div>
                </div>

                <div className="overflow-auto max-h-[calc(100vh-142px)] mt-10">
                    {sideBar.map((item: any, index: number) => (
                        <Fragment key={index}>
                            {/* ================= PARENT ================= */}
                            {item.link === "" ? (
                                <div
                                    className="flex cursor-pointer group gap-4 py-2 my-1 px-1 md:px-4"
                                    onClick={() => {
                                        const result = [...sideBar];
                                        result[index] = {
                                            ...result[index],
                                            isChildVisible: !item.isChildVisible,
                                        };
                                        setSideBar(result);
                                    }}
                                >
                                    <h6 className="text-gray-600 group-hover:text-black text-sm font-bold flex-1">
                                        {item.name}
                                    </h6>

                                    {item.child.length !== 0 && (
                                        <svg
                                            className={`w-3 fill-gray-600 group-hover:fill-black ${item.isChildVisible ? "rotate-0" : "-rotate-90"
                                                }`}
                                            viewBox="0 0 451.847 451.847"
                                        >
                                            <path d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z" />
                                        </svg>
                                    )}
                                </div>
                            ) : (
                                <Link
                                    to={item.link}
                                    onClick={() => setSideBarHide(true)}
                                    className={`flex cursor-pointer group py-2 my-1 rounded-md transition ${isActive(item.link)
                                        ? "bg-secondary text-white"
                                        : "hover:bg-blue-200"
                                        }`}
                                >
                                    <h6
                                        className={`text-sm font-bold px-4 flex-1 ${isActive(item.link)
                                            ? "text-white"
                                            : "text-gray-600 group-hover:text-black"
                                            }`}
                                    >
                                        {item.name}
                                    </h6>
                                </Link>
                            )}

                            {/* ================= CHILD ================= */}
                            {item.isChildVisible && (
                                <ul className="space-y-2 mt-1 pl-4">
                                    {item.child.map((childItem: any, childIndex: number) => (
                                        <li key={childIndex}>
                                            <Link
                                                to={childItem.link}
                                                onClick={() => setSideBarHide(true)}
                                                className={`text-sm flex items-center rounded-md px-4 py-1 transition ${isActive(childItem.link)
                                                    ? "bg-secondary text-white"
                                                    : "text-gray-600 hover:text-black hover:bg-blue-50"
                                                    }`}
                                            >
                                                <MdSubdirectoryArrowRight className="mr-2" />
                                                <span>{childItem.name}</span>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </Fragment>
                    ))}
                </div>
            </nav>
        </>

    )
}

export default Sidebar